<div [@scaleIn] *ngIf="visible" class="dialog" (click)="close(); $event.stopPropagation()">
    <div class="row nav-container">
      <div class="col-sm-12">
        <div class="row-info">
          
              
                <div class="row">
                  <div class="col-md-12">
                      <div class="card mx-auto d-block" id="main-card" (click)="$event.stopPropagation()">
                        
                        <button type="button" (click)="close(); $event.stopPropagation()" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>

                        <div class="container-fluid m-t-1">
                          <div class="row">
                            <div class="col-md-12">
                              <h3>{{property._source.name}}</h3>
                              <hr>
                            </div>
                          </div>
                    
                          <div class="row">
                            
                            <div class="col-md-12 nogutters" style="padding: 0px 5px">

                              <div class="alert alert-success" role="alert" *ngIf="successMessage">
                                {{successMessage}}
                              </div>

                              <div class="row w-100">
                                <div class="col">
                                  <div class="col-md-12 d-flex justify-content-center" *ngIf="property._source.image_url">
                                    <img src="../../../assets/images/logo_white.png" class="event_logo rounded" alt="...">
                                  </div>
                                </div>
                                
                                <div class="col-md-4 text-center" *ngIf="isVisible">
                                  <div class="d-flex justify-content-center m-t-1">
                                    <button (click)="onEvaluate(property)" type="button" class="btn btn-eval rounded-pill">REQUEST EVALUATION</button>
                                  </div>

                                  <div class="text-center" *ngIf="isLoading">
                                    <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
                                  </div>

                                </div>

                                <div class="col-md-12" *ngIf="property._source.description">    
                                  {{property._source.description}}
                                </div>
                              </div>


                              <div class="jumbotron d-flex justify-content-center" *ngIf="isVisible">
                                <div class="row w-100">
                                      <div class="col" *ngIf="property._source.attendance">
                                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                                              <div class="card border-success shadow text-success p-3 my-card" ><span class="fa fa-users" aria-hidden="true"></span></div>
                                              <div class="text-success text-center mt-3"><p>Attendance</p></div>
                                              <div class="text-success text-center mt-2"><h4>{{property._source.attendance}}</h4></div>
                                          </div>
                                      </div>
                                      <div class="col" *ngIf="property._source.propValue">
                                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                                              <div class="card border-success shadow text-success p-3 my-card"><span class="fa fa-money" aria-hidden="true"></span></div>
                                              <div class="text-success text-center mt-3"><p>Value</p></div>
                                              <div class="text-success text-center mt-2"><h4>{{property._source.propValue}}</h4></div>
                                          </div>
                                      </div>
                                      <div class="col" *ngIf="property._source.spend">
                                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                                              <div class="card border-success shadow text-success p-3 my-card" ><span class="fa fa-money" aria-hidden="true"></span></div>
                                              <div class="text-success text-center mt-3"><p>Sponsor fees</p></div>
                                              <div class="text-success text-center mt-2"><h4>{{property._source.spend | currency:'ZAR':'symbol-narrow'}}</h4></div>
                                          </div>
                                      </div>
                                      <div class="col" *ngIf="property._source.period">
                                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                                              <div class="card border-success shadow text-success p-3 my-card" ><span class="fa fa-calendar" aria-hidden="true"></span></div>
                                              <div class="text-success text-center mt-3"><p>Days</p></div>
                                              <div class="text-success text-center mt-2"><h4>{{property._source.period}}</h4></div>
                                          </div>
                                      </div>
                                      <div class="col" *ngIf="property._source.region">
                                        <div class="card border-success mx-sm-1 p-3 m-t-2">
                                            <div class="card border-success shadow text-success p-3 my-card" ><span class="fa fa-map-pin" aria-hidden="true"></span></div>
                                            <div class="text-success text-center mt-3"><p>Province</p></div>
                                            <div class="text-success text-center mt-2"><h4>{{property._source.region}}</h4></div>
                                        </div>
                                    </div>
                                </div>
                                
                              </div>

                              <!-- <div class="row align-items-center text-center m-t-2 m-b-4"  *ngIf="!isVisible">
                                <div class="col-sm-12 m-t-1">
                        
                                  <h4 class="mb-5">Explore the full capability of the GaniSponsor Market Place</h4>
                                  <a class="btn text-primary btn-signUp mb-4 px-4">Sign Up<i class="ml-2"></i></a>
                                  <p>Already have an account, <a class="pointer">Sign In</a></p> 
                                </div>
                              </div> -->

                              <!-- <div class="row w-100">
                                <div class="btn-boxEvaluate">
                                  <button class="btn btn-close_Evaluate" (click)="close()">
                                    <span>CLOSE</span>
                                  </button>
                                </div>
                                <button class="btn btn-primary">testing</button>
                              </div> -->

                            </div>
                          </div>
                          
                        </div>

                        <!-- <div class="row" *ngIf="evaluate_visible">
                          <h3>Evaluate Detailed Contents</h3>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="btn-boxEvaluate">
                                <button class="btn btn-two" (click)="close()">
                                  <span>CLOSE</span>
                                </button>
                              </div>
                            </div>
                          </div>    
                        </div> -->
                         
                      </div> 
                  </div>
                </div> 
                
                
          
            <div class="loader" [@fadeInOut]="isLoading ? 'on' : 'off'">
                <div id="loader"></div>
            </div>
        </div>   
          
      </div>
    </div>   
    
  </div>

 
  <!-- <app-tier-component *ngIf="displayTier"></app-tier-component> -->
  <!-- <app-create-quote [(visible)]="displayQuote" (success)="isQuoteSuccess($event)" [srequestObj]="srequestObj" [handymanObj]="handymanObj"></app-create-quote> -->
  
  <div *ngIf="visible" class="overlay" (click)="close()"></div> 
  
  